export default [
  {
    sid: "2391",
    title: "OTP Message",
    content:
      "Use {#otp#} as your OTP to access your {#company#}, OTP is confidential and valid for {#time#}",
    date: "02/04/2015",
    uniCode: "No / No",
    senderKey: "Key",
    action: "Default Template",
  },
  {
    sid: "2392",
    title: "Test Message",
    content: "This is a testing sms sent",
    date: "02/04/2015",
    senderKey: "Key",
    uniCode: "No / No",
    action: "Default Template",
  },
  {
    sid: "2393",
    title: "OTP Message",
    content: "This is a testing sms sent",
    date: "02/04/2015",
    senderKey: "Key",
    uniCode: "No / No",
    action: "Default Template",
  },
  {
    sid: "2394",
    title: "Test Message",
    content: "This is a testing sms sent",
    date: "02/04/2015",
    senderKey: "Key",
    uniCode: "No / No",
    action: "Default Template",
  },
];
